import { FunctionComponent } from "react";
import { Navbar } from "@App/Components/Navbar";
import { Footer } from "@App/Layouts/Footer";
import { Outlet } from "react-router-dom";

export type LayoutProps = {
  embedded?: boolean;
};

export const Layout: FunctionComponent<LayoutProps> = ({ embedded = false }: LayoutProps) => {
  return (
    <div className="text-neutral-900 min-h-screen flex flex-col justify-between antialiased">
      {!embedded && (
        <Navbar>
          <a href={"https://www.repareo.de"} title={"repareo.de"}>
            <img src="/images/logo-light.png" className="w-28 h-auto" alt="repareo" />
          </a>
        </Navbar>
      )}
      <div className={"grow"}>
        <Outlet />
      </div>
      {!embedded && <Footer b2c />}
    </div>
  );
};
